export default {
  namespaced: true,

  state: {
    globalOverlay: false,
    tableFooterProps: {
      'items-per-page-text': '',
      'items-per-page-options': [10, 20, 50, 100, -1]
    }
  },

  actions: {
    showOverlay({ commit }) {
      commit('globalOverlayToggle', { enabled: true });
    },

    hideOverlay({ commit }) {
      commit('globalOverlayToggle', { enabled: false });
    }
  },

  mutations: {
    globalOverlayToggle(state, { enabled }) {
      state.globalOverlay = enabled;
    }
  }
};
